import type en from '../en/subscriptions'
import type { Translation } from '../types'

/** Alert subscriptions: who is told when a network or device goes offline */
const subscriptions: Translation<typeof en> = {
  "subscriptions.scope.SITE": "Nur das Netzwerk",
  "subscriptions.scope.SITE_AND_DEVICES": "Netzwerk + Geräte",
  "subscriptions.scope.DEVICE": "Einzelnes Gerät",
  "subscriptions.blurb.SITE": "Meldung, wenn der Standort selbst offline geht",
  "subscriptions.blurb.SITE_AND_DEVICES": "Auch Meldungen für jedes Gerät darin",
  "subscriptions.blurb.DEVICE": "Meldungen nur für ein Gerät",
  "subscriptions.blurbDevices": { one: "Auch Meldungen für jedes Gerät darin ({count} Gerät)", other: "Auch Meldungen für jedes Gerät darin ({count} Geräte)" },
  "subscriptions.channel.EMAIL": "E-Mail",
  "subscriptions.unsubscribed": "Abgemeldet",
  "subscriptions.testSent": "Test per {channels} gesendet",
  "subscriptions.someFailed": "Einige Kanäle sind fehlgeschlagen",
  "subscriptions.testFailed": "Test fehlgeschlagen",
  "subscriptions.title": "Abonnements für Meldungen",
  "subscriptions.subtitle": "Erfahren Sie, wenn ein Netzwerk oder Gerät offline geht",
  "subscriptions.subscribe": "Abonnieren",
  "subscriptions.noPhone": "Keine Telefonnummer hinterlegt",
  "subscriptions.ready": "bereit",
  "subscriptions.unavailable": "nicht verfügbar",
  "subscriptions.empty": "Noch keine Abonnements. Abonnieren Sie ein Netzwerk, um zu erfahren, wenn es ausfällt.",
  "subscriptions.unknown": "Unbekannt",
  "subscriptions.paused": "pausiert",
  "subscriptions.alertsAfter": "Meldung nach {duration} Ausfall",
  "subscriptions.reminderEvery": "Erinnerung alle {duration}",
  "subscriptions.reminderEveryMax": "Erinnerung alle {duration} (höchstens {max})",
  "subscriptions.oneMessage": "Eine Nachricht pro Ausfall",
  "subscriptions.recoveryOn": "Nachricht bei Wiederherstellung an",
  "subscriptions.quiet": "Ruhe {from}–{to}",
  "subscriptions.muted": "Stummgeschaltet:",
  "subscriptions.unmute": "Stummschaltung aufheben",
  "subscriptions.unmuted": "{name} nicht mehr stummgeschaltet",
  "subscriptions.mutedName": "{name} stummgeschaltet",
  "subscriptions.muteDevice": "Ein Gerät in diesem Netzwerk stummschalten",
  "subscriptions.history": "Versandverlauf",
  "subscriptions.sendTest": "Einen Test senden",
  "subscriptions.unsubscribe": "Abmelden",
  "subscriptions.unsubscribeConfirm": "Von diesen Meldungen abmelden?",
  "subscriptions.historyEmpty": "Noch keine Meldungen gesendet – seit Ihrem Abonnement ist nichts offline gegangen.",
  "subscriptions.target": "Ziel",
  "subscriptions.downSince": "Offline seit",
  "subscriptions.messages": "Nachrichten",
  "subscriptions.state": "Status",
  "subscriptions.reminders": { one: "({count} Erinnerung)", other: "({count} Erinnerungen)" },
  "subscriptions.state.PENDING": "wartet",
  "subscriptions.state.NOTIFIED": "gesendet",
  "subscriptions.state.RECOVERED": "wiederhergestellt",
  "subscriptions.newTitle": "Meldungen abonnieren",
  "subscriptions.network": "Netzwerk *",
  "subscriptions.chooseNetwork": "Wählen Sie ein Netzwerk…",
  "subscriptions.watchWhat": "Was möchten Sie beobachten?",
  "subscriptions.device": "Gerät *",
  "subscriptions.chooseDevice": "Wählen Sie ein Gerät…",
  "subscriptions.sendVia": "Meldungen senden per *",
  "subscriptions.rcsNote": "RCS kommt in der Nachrichten-App des Telefons an. iPhones in den Niederlanden erreicht es noch nicht.",
  "subscriptions.rcsNoteTwilio": "RCS kommt in der Nachrichten-App des Telefons an. iPhones in den Niederlanden erreicht es noch nicht; mit einer SMS-Nummer im Twilio-Dienst erhalten sie eine SMS.",
  "subscriptions.howOften": "Wie oft",
  "subscriptions.wait": "Warten vor der Meldung",
  "subscriptions.waitHint": "Minuten – ignoriert kurze Aussetzer und Neustarts",
  "subscriptions.remind": "Mich erinnern, solange es offline bleibt",
  "subscriptions.remindHint": "Standardmäßig aus – Sie erhalten genau eine Nachricht pro Ausfall.",
  "subscriptions.every": "alle",
  "subscriptions.remindEvery": "Erinnern alle",
  "subscriptions.stopAfter": "aufhören nach",
  "subscriptions.stopAfterLabel": "Nach so vielen Erinnerungen aufhören",
  "subscriptions.remindersWord": "Erinnerungen",
  "subscriptions.recovers": "Mich benachrichtigen, wenn es wieder läuft",
  "subscriptions.recoversHint": "Eine Nachricht, wenn es wieder online ist",
  "subscriptions.quietHours": "Ruhezeiten",
  "subscriptions.quietHint": "Nachrichten werden bis zum Ende des Zeitfensters zurückgehalten",
  "subscriptions.quietStart": "Beginn der Ruhezeiten",
  "subscriptions.quietEnd": "Ende der Ruhezeiten",
  "subscriptions.to": "bis",
  "subscriptions.subscribed": "Abonniert",
  "subscriptions.subscribeFailed": "Abonnieren fehlgeschlagen",
  "subscriptions.devicesIn": "Geräte in {name}",
  "subscriptions.muteInfo": "Schalten Sie ein Gerät stumm, um seine Meldungen zu stoppen; der Rest des Netzwerks bleibt abonniert.",
  "subscriptions.noDevices": "Keine Geräte in diesem Netzwerk gefunden",
  "subscriptions.unmuteTitle": "Stummschaltung aufheben – Meldungen fortsetzen",
  "subscriptions.muteTitle": "Stummschalten – Meldungen für dieses Gerät stoppen",
  "subscriptions.mute": "Stummschalten",
  "subscriptions.done": "Fertig",
  "subscriptions.notChanged": "Nicht geändert",
  "subscriptions.channel.PUSH": "Push (Telefon-App)",
  "subscriptions.pushPhones": "Telefone mit Push: {n}",
  "subscriptions.pushFirst.first": {"one": "Push geht zuerst. {channel} folgt nach {count} Minute, wenn Sie den Standort nicht geöffnet haben.", "other": "Push geht zuerst. {channel} folgt nach {count} Minuten, wenn Sie den Standort nicht geöffnet haben."},
  "subscriptions.pushFirst.atOnce": "{channel} geht sofort: Auf keinem Ihrer Telefone ist Push erlaubt (Profil → Telefon-App).",
  "subscriptions.pushFirst.automatic": "Push wird für Ihre WhatsApp- und RCS-Meldungen ohnehin zuerst gesendet.",
}

export default subscriptions
